/** Публичный номер заказа для UI; API по-прежнему идентифицирует заказ по числовому id. */
export function orderDisplayNumber(order) {
  if (!order) return '';
  const n = order.public_order_number;
  if (n != null && String(n).trim() !== '') {
    return String(n);
  }
  return String(order.id);
}
